import React, { Component } from "react";
import clsx from "clsx";
import * as Icon from "react-feather";

import PlaybookReviewService from "../../services/PlaybookReviewService";

import "./agent-finding-proof.css";

class AgentFindingProof extends Component {
	render() {
		const { proof, cardAccount, onSeeRows } = this.props;
		if (!proof) return null;
		const { tone, summary } = PlaybookReviewService.describeProof({ proof, cardAccount });
		const facts = PlaybookReviewService.describeProofFacts({ proof, cardAccount });
		const isFromTheRows = tone === "verified" || tone === "failing";
		const canSeeRows = isFromTheRows && !!onSeeRows;

		return (
			<div className={clsx("agent-finding-proof", `agent-finding-proof--${tone}`)} data-test="agent-finding-proof">
				<span className="agent-finding-proof__summary">
					{tone === "verified" && <Icon.CheckCircle size={13} className="agent-finding-proof__summary-icon" />}
					{tone === "failing" && <Icon.AlertCircle size={13} className="agent-finding-proof__summary-icon" />}
					{tone === "code" && <Icon.Cpu size={13} className="agent-finding-proof__summary-icon" />}
					{summary}
				</span>
				{facts.length > 0 && (
					<span className="agent-finding-proof__facts">
						{facts.map(fact => (
							<span key={fact.key} className={clsx("agent-finding-proof__fact", `agent-finding-proof__fact--${fact.tone}`)}>
								{fact.tone === "verified" && <Icon.Check size={12} className="agent-finding-proof__fact-mark" />}
								{fact.tone === "failing" && <Icon.X size={12} className="agent-finding-proof__fact-mark" />}
								{fact.label && <span className="agent-finding-proof__fact-label">{fact.label}</span>}
								<span className="agent-finding-proof__fact-value">{fact.value}</span>
							</span>
						))}
					</span>
				)}
				{canSeeRows && (
					<button type="button" className="tk-text-action agent-finding-proof__see-rows" onClick={onSeeRows}>
						See the rows <Icon.ChevronRight size={12} />
					</button>
				)}
			</div>
		);
	}
}

export default AgentFindingProof;
